import Common from '../../../Common';
import KeyValue from './userData/KeyValue';

export interface CustomerUserData {
	building: string
	floor: string
	location: string
	manager: string
	nickname: string
	office: string
	place: string
	plant: string
	room: string
	sales: string
	section: string
	subsection: string
	title: string
}

const UserData = class extends Common {
	keyValue: InstanceType<typeof KeyValue>;

	constructor(headers: ApiHeaders) {
		super(headers)

		this.keyValue = new KeyValue(headers);
	}

	read(companyId: id, userId: id) {
		return this.get(`/company/${companyId}/customerdata/userdata/${userId}`)
	}

	update(
		companyId: id,
		userId: id,
		data: CustomerUserData
	) {
		return this.patch(`/company/${companyId}/customerdata/userdata/${userId}`, data)
	}
}

export default UserData
